/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacyAuditSummary } from 'app/shared/model/pharmacy-audit-summary.model';
import { IPharmacyStock } from 'app/shared/model/pharmacy-stock.model';
import { IPharmacyConsumableStock } from 'app/shared/model/pharmacy-consumable-stock.model';
import { IPharmacyImplantStock } from 'app/shared/model/pharmacy-implant-stock.model';
import { QtyType } from 'app/shared/model/enumerations/qty-type.model';

export interface IPharmacyAuditItem {
  id?: string;
  quantity?: number;
  expectedQty?: number;
  qtyType?: keyof typeof QtyType | null;
  active?: boolean;
  microSec?: number;
  lastupdated?: number;
  timestampentry?: number;
  cursor?: number;
  summary?: IPharmacyAuditSummary;
  drugStock?: IPharmacyStock | null;
  consumableStock?: IPharmacyConsumableStock | null;
  implantStock?: IPharmacyImplantStock | null;
}

export const defaultValue: Readonly<IPharmacyAuditItem> = {
  active: false,
};
